export const events = {
  marketing: {
    category: "Marketing Asset",
    action: "Click",
    labels: [
      "Marketing asset #1",
      "Marketing asset #2",
      "Marketing asset #3",
      "Marketing asset #4",
      "Marketing asset #5",
    ],
  },
  productRecommend: {
    category: "Product Recommend",
    action: "Click",
    label: "Product recommend: ",
  },
  socialAccount: {
    category: "Social Account",
    action: "Click",
    label: "Link social: ",
  },
};
